import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { FreewallPopup } from './components/FreewallPopup';
import Assinar from './pages/Assinar';
import HomePage from './pages/HomePage_may';
import DashboardPage from './pages/DashboardPage';
import MarketOverviewPage from './pages/MarketOverviewPage';
import CryptoPage from './pages/CryptoPage';
import CryptoAssetPage from './pages/CryptoAssetPage';
import RRTVMarketPage from './pages/RRTVMarketPage';
import CalendarsPage from './pages/CalendarsPage';
import { AssetPage } from './pages/AssetPage';
import ThesisPage from './pages/ThesisPage';
import ThesisWarshPage from './pages/ThesisWarshPage';
import StocksPage from './pages/StocksPage';
import FixedIncomePage from './pages/FixedIncomePage';
import FXCurrenciesPage from './pages/FXCurrenciesPage';
import { WorldIndicesPage } from './pages/IndicesPage';
import TourismFXPage from './pages/TourismFXPage';
import CommercialFXPage from './pages/dolar_comercial';
import MinhaConta from './pages/MinhaConta';
import EsqueciSenha from './pages/EsqueciSenha';
import RedefinirSenha from './pages/RedefinirSenha';
import AlertsPage from './pages/AlertsPage';
import AssetTVPage from './pages/AssetTVPage';
import CurvaDeJurosTV from './pages/CurvaDeJurosTV';
import IndexTVPage from './pages/IndexTVPage';
import IndexHeroTV from './pages/IndexHeroTv';
// no topo, junto dos outros imports de componente:
import WeekAheadTV from './pages/WeekAheadTV';

// dentro do <Routes>...</Routes>:
//import StockBoardTV from './pages/StockBoardTV';
import BoardTV from './pages/BoardTV';
// import ContactPage from './pages/ContactPage';
import './App.css';


function App() {
  const [isDark, setIsDark] = useState(true);

  const toggleTheme = () => setIsDark(d => !d);

  // Define theme based on isDark
  const theme = {
    // Background colors
    bg:        isDark ? '#0f172a' : '#ffffff',
    cardBg:    isDark ? 'rgba(30, 41, 59, 0.8)'  : 'rgba(255, 255, 255, 0.9)',
    headerBg:  isDark ? 'rgba(15, 23, 42, 0.95)' : 'rgba(255, 255, 255, 0.95)',

    // Text colors
    textPrimary:   isDark ? '#ffffff'                  : '#1e293b',
    textSecondary: isDark ? 'rgba(255, 255, 255, 0.7)' : '#64748b',
    textTertiary:  isDark ? 'rgba(255, 255, 255, 0.5)' : '#94a3b8',

    // Border colors
    border:      isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
    borderHover: isDark ? 'rgba(212, 175, 55, 0.3)'  : 'rgba(212, 175, 55, 0.5)',

    // Accent colors
    accent:      '#D4AF37',
    accentHover: '#B8941F',

    // Status colors
    positive: '#10b981',
    negative: '#ef4444',
    neutral:  '#6b7280',
  };

  return (
    <Router>
      <AuthProvider>
        <FreewallPopup />
        <div className="app-container">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/assinar" element={<Assinar />} />
            <Route path="/entrar" element={<MinhaConta />} />
            <Route path="/esqueci-senha" element={<EsqueciSenha />} />
            <Route path="/redefinir-senha" element={<RedefinirSenha />} />
            <Route path="/mercado" element={<MarketOverviewPage />} />
            <Route path="/calendario" element={<CalendarsPage />} />
            <Route path="/stocks" element={<StocksPage />} />
            <Route path="/bonds" element={<FixedIncomePage />} />
            <Route path="/alertas" element={<AlertsPage />} />
            <Route path="/fx" element={<FXCurrenciesPage />} />
            <Route path="/dolarturismo" element={<TourismFXPage />} />
            <Route path="/dolarcomercial" element={<CommercialFXPage />} />
            <Route path="/indices" element={<WorldIndicesPage />} />
            <Route path="/thesis" element={<ThesisPage />} />
            <Route path="/crypto" element={<CryptoPage />} />
            <Route path="/rrtv" element={<RRTVMarketPage />} />
            <Route path="/tv/week-ahead" element={<WeekAheadTV />} />
            <Route path="/thesis/warsh" element={<ThesisWarshPage />} />
            <Route path="/tv/asset/:type/:symbol" element={<AssetTVPage/>} />
            <Route path="/tv/index" element={<IndexTVPage />} />
            <Route path="/tv/board" element={<BoardTV/>} /> 
            <Route path="/tv/index-hero" element={<IndexHeroTV/>} />   
            <Route path="/tv/curva-juros" element={<CurvaDeJurosTV/>} />
            {/* <Route path="/tv/board" element={<StockBoardTV/>} /> */}
            <Route path="/asset/:type/:symbol" element={<AssetPage  theme={theme} 
                  isDark={isDark}/>} />
            
            {/* NEW: Crypto-specific asset page */}
            <Route path="/crypto/:symbol" element={<CryptoAssetPage />} />
            {/* <Route path="/entrar" element={<LoginPage />} /> */}
            {/* <Route path="/contato" element={<ContactPage />} /> */}
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;